/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useMemo, useState } from 'react'
import {
  Avatar,
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  Grid,
  LinearProgress,
  Typography
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { ReactComponent as CheckboxIcon } from 'public/assets/Checkbox.svg'
import { ReactComponent as CheckboxOffIcon } from 'public/assets/Checkbox-off.svg'
import { useNewProfileSpecialistCreateStyles } from './profile-freelancer-create-new.styles'
import {
  employmentType,
  featuresOptions,
  FreelancerCreateProfileForm,
  freelanceType,
  newProfileSpecialistCreateValidationSchemas,
  sheduleType,
  useNewMutationCreateProfileFreelancer,
  // useQueryProfileSpecialistFeatures,
  useQueryProfileSpecialistProfessionalCategories,
  useQueryProfileSpecialistSpecializations
  // useQueryProfileSpecialistProfessionalCategories
} from '../common'
import { useFormik } from 'formik'
import { TranslationDictionary, useLocale } from '@plandi/common'
import {
  useQueryProfileCity,
  useQueryProfileCountry
} from '../../profiles/common'
import { CustomTextField } from '../../custom-text-field'
import { CustomSelect } from '../../custom-select'
import dayjs from 'dayjs'
import Chip from '@material-ui/core/Chip'
import clsx from 'clsx'
import { CropPictureModal } from '../../../common/crop-picture-modal'
interface IProfileSpecialistrCreateNewProps {
  type: 'freelancer' | 'worker'
  locale: string
  translate?: TranslationDictionary['data']
}

export const ProfileSpecialistrCreateNew: FC<
  IProfileSpecialistrCreateNewProps
> = ({ type, translate }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const [progress, setProgress] = useState(0)
  const [date, setDate] = useState({ day: 1, year: 1900, month: 2 })
  const [skills, setSkills] = useState('')
  const locale = useLocale()
  const daysInMonth = useMemo(() => {
    return Array.from(
      {
        length: dayjs()
          .set('month', date.month)
          .set('year', date.year)
          .daysInMonth()
      },
      (_, i) => {
        return { text: (i + 1).toString(), value: i + 1 }
      }
    )
  }, [date])

  const stepData = useMemo<Record<number, Record<string, string>>>(
    () => ({
      0: {
        heading: locale === 'ru' ? 'Основные данные' : 'Key data',
        description:
          locale === 'ru'
            ? // eslint-disable-next-line max-len
              'Заполните данные о себе, чтобы ваша анкета выглядела привлекательно для потенциальных заказчиков и вас легко можно было найти\n' +
              'в нашем каталоге'
            : 'Fill in your details so that your profile looks attractive to potential\
             customers and you can be easily found in our catalog'
      },
      1: {
        heading: locale === 'ru' ? 'Сфера деятельности' : 'Scope of activity',
        description:
          locale === 'ru'
            ? // eslint-disable-next-line max-len
              'Подробно расскажите о сфере деятельности и условиях работы, чтобы получать более точные заказы, подходящие именно вам'
            : // eslint-disable-next-line max-len
              'Describe in detail the scope of activity and working conditions to receive more accurate orders that suit you'
      },
      2: {
        heading: locale === 'ru' ? 'Условия работы' : 'Working conditions',
        description:
          locale === 'ru'
            ? // eslint-disable-next-line max-len
              'Как можно подробнее заполните предпочитаемые условия работы для более эффективного поиска'
            : // eslint-disable-next-line max-len
              'Fill in the preferred working conditions as thoroughly as possible for more effective search results'
      }
    }),
    []
  )

  const { data: countries } = useQueryProfileCountry()

  const { data: specializations } = useQueryProfileSpecialistSpecializations()

  // const { data: features } = useQueryProfileSpecialistFeatures()
  const mutation = useNewMutationCreateProfileFreelancer(type)

  const formik = useFormik<FreelancerCreateProfileForm>({
    initialValues: {
      fullName: '',
      birthday: null,
      gender: 'male',
      mainActivitySpecializationId: undefined,
      avatarUrl: undefined,
      activitySpecializations: [],
      features: [],
      skills: [],
      aboutMe: '',
      type: type,
      countryId: '',
      cityId: '',
      salary: '',
      salaryhourly: undefined,
      salaryType: 'Agreement',
      employments: [],
      schedules: [],
      remoteWork: false,
      allSelectedOptions: []
    },
    enableReinitialize: true,
    validationSchema:
      newProfileSpecialistCreateValidationSchemas(translate)[currentStepIndex],
    onSubmit: async (values, { setSubmitting, validateForm }) => {
      if (currentStepIndex !== 2) {
        await validateForm()
        setCurrentStepIndex(currentStepIndex + 1)
        setSubmitting(false)
        return
      }
      mutation.mutate({
        ...values,
        birthday: (values.birthday as unknown as Date).toISOString()
      })
    }
  })

  const { data: professionalCategories } =
    useQueryProfileSpecialistProfessionalCategories(
      formik.values.mainActivitySpecializationId as number,
      {
        enabled: (formik.values.mainActivitySpecializationId as number) > 0
      }
    )
  // const specializationId = formik.values.mainActivitySpecializationId
  //   ? Number(formik.values.mainActivitySpecializationId)
  //   : null

  // const { data: professionalCategories } =
  //   useQueryProfileSpecialistProfessionalCategories(specializationId, {
  //     enabled: formik.values.mainActivitySpecializationId > 0
  //   })

  const { data: cities } = useQueryProfileCity({
    select: (data) =>
      data?.filter((city) => city.country_id === formik.values.countryId)
  })

  const classes = useNewProfileSpecialistCreateStyles()

  useEffect(() => {
    const formDate = dayjs().year(date.year).month(date.month).date(date.day)
    if (
      formDate.isSame(formik.values.birthday, 'year') &&
      formDate.isSame(formik.values.birthday, 'month') &&
      formDate.isSame(formik.values.birthday, 'date')
    ) {
      return
    }
    formik.setFieldValue('birthday', formDate.toDate())
  }, [date, formik])

  useEffect(() => {
    let percentile = 0
    if (formik.values.fullName.length > 2) {
      percentile += 100 / 5
    }
    if (formik.values.countryId && formik.values.cityId) {
      percentile += 100 / 5
    }
    if (
      formik.values.mainActivitySpecializationId &&
      formik.values.activitySpecializations.length > 0
    ) {
      percentile += 100 / 5
    }
    if (
      formik.values.schedules.length > 0 &&
      formik.values.employments.length > 0
    ) {
      percentile += 100 / 5
    }
    if (formik.values.remoteWork || Number(formik.values.salary) > 0) {
      percentile += 100 / 5
    }
    setProgress(Math.ceil(percentile))
  }, [formik.values])

  useEffect(() => {
    if (skills.endsWith(',') && skills.length > 3) {
      formik.setFieldValue('skills', [
        ...(formik.values.skills as string[]),
        skills.trim().replace(',', '')
      ])
      setSkills('')
    }
  }, [formik, skills])

  useEffect(() => {
    formik.setFieldValue('allSelectedOptions', [
      ...(formik.values.schedules ?? []),
      ...(formik.values.employments ?? [])
    ])
  }, [formik.values.schedules, formik.values.employments])

  // useEffect(() => {
  //   if (mutation.isSuccess) {
  //     formik.resetForm()
  //     formik.setSubmitting(false)
  //     setCurrentStepIndex(3)
  //   }
  //   if (mutation.isError) formik.setSubmitting(false)
  // }, [mutation.isSuccess, mutation.isError])

  return (
    <Grid
      container
      className={classes.root}
      spacing={4}
      justifyContent="center"
    >
      <>
        <Grid item xs={12} md={6}>
          <div className={classes.stateInfo}>
            <div>
              <Typography className={classes.progressLabel}>
                <Typography component={'span'} className={classes.percent}>
                  {progress}%
                </Typography>{' '}
                {locale === 'ru' ? 'Анкета специалиста' : 'Profile Specialist'}
              </Typography>
              <LinearProgress
                variant="determinate"
                color={'secondary'}
                value={progress}
                classes={{ root: classes.progressRoot }}
              />
            </div>
            <Typography component={'h2'} className={classes.heading}>
              {stepData[currentStepIndex]['heading']}
            </Typography>
            <Typography className={classes.description}>
              {stepData[currentStepIndex]['description']}
            </Typography>
          </div>
        </Grid>
        <Grid item xs={12} md={6} classes={{ root: classes.formGridRoot }}>
          <Card elevation={0} classes={{ root: classes.card }}>
            <form onSubmit={formik.handleSubmit}>
              {currentStepIndex === 0 && (
                <div className={classes.formWrapper}>
                  <div
                    style={{
                      position: 'relative',
                      width: 'fit-content',
                      margin: '0 auto'
                    }}
                  >
                    <Avatar
                      className={classes.avatar}
                      src={
                        (formik?.values?.avatarUrl as unknown as string) ?? ''
                      }
                    />

                    <div className={classes.editIcon}>
                      <CropPictureModal
                        onUploadImage={(data) =>
                          formik.setFieldValue('avatarUrl', data.url)
                        }
                        uploadOptions={{ isAvatar: true }}
                        buttonText=""
                        translate={translate}
                        editAvatarNew
                      />
                    </div>
                  </div>
                  {Boolean(formik.errors.avatarUrl) &&
                    formik.touched.avatarUrl && (
                      <Typography className={classes.avatarError}>
                        {formik.errors.avatarUrl}
                      </Typography>
                    )}
                  <div>
                    <CustomTextField
                      id={'fio-label'}
                      placeholder={locale === 'ru' ? 'ФИО' : 'Full Name'}
                      label={locale === 'ru' ? 'ФИО' : 'Full Name'}
                      name="fullName"
                      fullWidth
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur('fullName')}
                      value={formik.values.fullName}
                      touched={formik.touched.fullName}
                      errors={formik.errors.fullName}
                      disabled={formik.isSubmitting}
                    />
                  </div>
                  <div>
                    <Typography className={classes.dobLabel}>
                      {locale === 'ru' ? 'Дата рождения' : 'Date of birth'}
                    </Typography>
                    <div className={classes.dobInputWrapper}>
                      <CustomSelect
                        options={daysInMonth}
                        className={classes.selector}
                        label={locale === 'ru' ? 'День' : 'Birthday'}
                        onChange={(event) => {
                          setDate((prev) => ({
                            ...prev,
                            day: event.target.value as number
                          }))
                        }}
                        onBlur={formik.handleBlur('birthday')}
                        error={
                          Boolean(formik.errors.birthday) &&
                          formik.touched.birthday
                        }
                      />
                      <CustomSelect
                        options={[
                          {
                            text: locale === 'ru' ? 'Январь' : 'January',
                            value: 0
                          },
                          {
                            text: locale === 'ru' ? 'Февраль' : 'February',
                            value: 1
                          },
                          {
                            text: locale === 'ru' ? 'Март' : 'March',
                            value: 2
                          },
                          {
                            text: locale === 'ru' ? 'Апрель' : 'April',
                            value: 3
                          },
                          { text: locale === 'ru' ? 'Май' : 'May', value: 4 },
                          { text: locale === 'ru' ? 'Июнь' : 'June', value: 5 },
                          { text: locale === 'ru' ? 'Июль' : 'July', value: 6 },
                          {
                            text: locale === 'ru' ? 'Август' : 'August',
                            value: 7
                          },
                          {
                            text: locale === 'ru' ? 'Сентябрь' : 'September',
                            value: 8
                          },
                          {
                            text: locale === 'ru' ? 'Октябрь' : 'October',
                            value: 9
                          },
                          {
                            text: locale === 'ru' ? 'Ноябрь' : 'November',
                            value: 10
                          },
                          {
                            text: locale === 'ru' ? 'Декабрь' : 'December',
                            value: 11
                          }
                        ]}
                        className={classes.selector}
                        onChange={(event) => {
                          setDate((prev) => ({
                            ...prev,
                            month: event.target.value as number
                          }))
                        }}
                        onBlur={formik.handleBlur('birthday')}
                        error={
                          Boolean(formik.errors.birthday) &&
                          formik.touched.birthday
                        }
                        label={locale === 'ru' ? 'Месяц' : 'Month'}
                      />
                      <CustomSelect
                        options={Array.from({ length: 100 }, (_, i) => {
                          const year: number = dayjs().get('year') - i
                          return { text: year.toString(), value: year }
                        })}
                        className={classes.selector}
                        onChange={(event) => {
                          setDate((prev) => ({
                            ...prev,
                            year: event.target.value as number
                          }))
                        }}
                        onBlur={formik.handleBlur('birthday')}
                        error={
                          Boolean(formik.errors.birthday) &&
                          formik.touched.birthday
                        }
                        label={locale === 'ru' ? 'Год' : 'Year'}
                      />
                    </div>
                    {Boolean(formik.errors.birthday) &&
                      formik.touched.birthday && (
                        <Typography className={classes.dobError}>
                          {formik.errors.birthday}
                        </Typography>
                      )}
                  </div>
                  <div className={classes.inputStack}>
                    <Typography className={classes.dobLabelLocation}>
                      {locale === 'ru' ? 'Местонахождение' : 'Location'}
                    </Typography>
                    <CustomSelect
                      options={countries?.map((record) => ({
                        value: record.id as NonNullable<typeof record.id>,
                        text: record.name as NonNullable<typeof record.name>
                      }))}
                      onBlur={formik.handleBlur('countryId')}
                      error={
                        Boolean(formik.errors.countryId) &&
                        formik.touched.countryId
                      }
                      onChange={formik.handleChange}
                      value={formik.values.countryId}
                      name={'countryId'}
                      label={locale === 'ru' ? 'Страна' : 'Country'}
                      errorText={formik.errors.countryId}
                    />
                    <CustomSelect
                      options={cities?.map((record) => ({
                        value: record.id as NonNullable<typeof record.id>,
                        text: record.name as NonNullable<typeof record.name>
                      }))}
                      onBlur={formik.handleBlur('cityId')}
                      value={formik.values.cityId}
                      error={
                        Boolean(formik.errors.cityId) && formik.touched.cityId
                      }
                      onChange={formik.handleChange}
                      name={'cityId'}
                      label={locale === 'ru' ? 'Город' : 'City'}
                      errorText={formik.errors.cityId}
                      disabled={!formik.values.countryId}
                    />
                  </div>
                </div>
              )}
              {currentStepIndex === 1 && (
                <div className={classes.formWrapper}>
                  <div className={classes.inputStack}>
                    <Typography className={classes.dobLabelLocation}>
                      {locale === 'ru' ? 'Деятельность' : 'Activity'}
                    </Typography>
                    <CustomSelect
                      value={formik.values.mainActivitySpecializationId}
                      name={'mainActivitySpecializationId'}
                      label={
                        (formik.values.mainActivitySpecializationId as number) >
                        0
                          ? undefined
                          : locale === 'ru'
                          ? 'Вид деятельности'
                          : 'Type of activity'
                      }
                      error={
                        Boolean(formik.errors.mainActivitySpecializationId) &&
                        formik.touched.mainActivitySpecializationId
                      }
                      errorText={formik.errors.mainActivitySpecializationId}
                      onChange={formik.handleChange}
                      disabled={
                        formik.values.activitySpecializations.length > 0
                      }
                      options={specializations?.map((record) => ({
                        value: record.id as number,
                        text: record.name as string
                      }))}
                    />
                    <CustomSelect
                      multiple
                      value={formik.values.activitySpecializations}
                      name={'activitySpecializations'}
                      label={
                        formik.values.activitySpecializations.length > 0
                          ? undefined
                          : locale === 'ru'
                          ? 'Специализация'
                          : 'Specialization'
                      }
                      error={
                        Boolean(formik.errors.activitySpecializations) &&
                        formik.touched.activitySpecializations
                      }
                      errorText={
                        Array.isArray(formik.errors.activitySpecializations)
                          ? formik.errors.activitySpecializations[0]
                          : formik.errors.activitySpecializations
                      }
                      onChange={formik.handleChange}
                      disabled={(professionalCategories ?? [])?.length < 1}
                      options={professionalCategories?.map((record) => ({
                        value: record.id as number,
                        text: record.name as string
                      }))}
                      renderValue={(selected) =>
                        `${
                          locale === 'ru' ? 'Специализация' : 'Specialization'
                        }${
                          (selected as string[]).length > 0
                            ? ` (${(selected as string[]).length})`
                            : ''
                        }`
                      }
                    />
                    {formik.values.activitySpecializations.length > 0 && (
                      <div className={classes.chipRow}>
                        {formik.values.activitySpecializations?.map(
                          (spec, idx) => (
                            <Chip
                              key={idx}
                              classes={{
                                root: classes.chipRoot,
                                label: classes.chipLabel
                              }}
                              label={
                                <div className={classes.chipLabelContainer}>
                                  <Typography className={classes.chipLabel}>
                                    {
                                      professionalCategories?.find(
                                        (cat) => cat.id === spec
                                      )?.name
                                    }
                                  </Typography>
                                  <CloseIcon
                                    fontSize={'small'}
                                    onClick={() =>
                                      formik.setFieldValue(
                                        'activitySpecializations',
                                        formik.values.activitySpecializations.filter(
                                          (item) => item !== spec
                                        )
                                      )
                                    }
                                  />
                                </div>
                              }
                            />
                          )
                        )}
                      </div>
                    )}
                  </div>
                  <div>
                    <CustomTextField
                      label={locale === 'ru' ? 'Навыки' : 'Skills'}
                      id={'skills'}
                      fullWidth
                      placeholder={
                        locale === 'ru'
                          ? 'Разделяйте навыки запятой'
                          : 'Separate skills with a comma'
                      }
                      value={skills}
                      onChange={(event) => setSkills(event.target.value)}
                    />
                    {(formik.values?.skills?.length ?? 0) > 0 && (
                      <div
                        className={clsx(classes.chipRow, classes.skillChips)}
                      >
                        {formik.values.skills?.map((skill, idx) => (
                          <Chip
                            key={idx}
                            classes={{
                              root: classes.chipRoot,
                              label: classes.chipLabel
                            }}
                            label={
                              <div className={classes.chipLabelContainer}>
                                <Typography className={classes.chipLabel}>
                                  {skill}
                                </Typography>
                                <CloseIcon
                                  fontSize={'small'}
                                  onClick={() =>
                                    formik.setFieldValue(
                                      'skills',
                                      formik.values.skills?.filter(
                                        (item) => item !== skill
                                      )
                                    )
                                  }
                                />
                              </div>
                            }
                          />
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {currentStepIndex === 2 && (
                <div className={classes.formWrapper}>
                  <div className={classes.inputStack}>
                    <Typography className={classes.dobLabelLocation}>
                      {type === 'freelancer'
                        ? locale === 'ru'
                          ? 'Статус'
                          : 'Status'
                        : locale === 'ru'
                        ? 'График работы'
                        : 'Work schedule'}
                    </Typography>
                    <CustomSelect
                      multiple
                      value={formik.values.schedules}
                      name={'schedules'}
                      className={classes.selector}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur('schedules')}
                      error={
                        Boolean(formik.errors.schedules) &&
                        formik.touched.schedules
                      }
                      errorText={
                        locale === 'ru' ? 'Обязательное поле' : 'Required field'
                      }
                      disabled={formik.isSubmitting}
                      options={
                        type === 'freelancer'
                          ? Object.entries(freelanceType(translate))?.map(
                              ([key, value]) => ({
                                value: key as NonNullable<typeof key>,
                                text: value as NonNullable<typeof value>
                              })
                            )
                          : Object.entries(sheduleType(translate))?.map(
                              ([key, value]) => ({
                                value: key as NonNullable<typeof key>,
                                text: value as NonNullable<typeof value>
                              })
                            )
                      }
                      renderValue={(selected) =>
                        `${
                          type === 'freelancer'
                            ? locale === 'ru'
                              ? 'Статус'
                              : 'Status'
                            : locale === 'ru'
                            ? 'График работы'
                            : 'Work schedule'
                        }${
                          (selected as string[]).length > 0
                            ? ` (${(selected as string[]).length})`
                            : ''
                        }`
                      }
                    />
                    {formik.values.schedules.length > 0 && (
                      <div className={classes.chipRow}>
                        {formik.values.schedules?.map((schedule, idx) => (
                          <Chip
                            key={idx}
                            classes={{
                              root: classes.chipRoot,
                              label: classes.chipLabel
                            }}
                            label={
                              <div className={classes.chipLabelContainer}>
                                <Typography className={classes.chipLabel}>
                                  {type === 'freelancer'
                                    ? freelanceType(translate)[
                                        schedule as unknown as keyof ReturnType<
                                          typeof freelanceType
                                        >
                                      ]
                                    : sheduleType(translate)[schedule]}
                                </Typography>
                                <CloseIcon
                                  fontSize={'small'}
                                  onClick={() =>
                                    formik.setFieldValue(
                                      'schedules',
                                      formik.values.schedules.filter(
                                        (item) => item !== schedule
                                      )
                                    )
                                  }
                                />
                              </div>
                            }
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  <div className={classes.inputStack}>
                    <Typography className={classes.dobLabelLocation}>
                      {locale === 'ru' ? 'Занятость' : 'Employment'}
                    </Typography>
                    <CustomSelect
                      multiple
                      value={formik.values.employments}
                      name={'employments'}
                      className={classes.selector}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur('employments')}
                      error={
                        Boolean(formik.errors.employments) &&
                        formik.touched.employments
                      }
                      errorText={
                        locale === 'ru' ? 'Обязательное поле' : 'Required field'
                      }
                      disabled={formik.isSubmitting}
                      options={Object.entries(employmentType(translate))?.map(
                        ([key, value]) => ({
                          value: key as NonNullable<typeof key>,
                          text: value as NonNullable<typeof value>
                        })
                      )}
                      renderValue={(selected) =>
                        `${locale === 'ru' ? 'Занятость' : 'Employment'}${
                          (selected as string[]).length > 0
                            ? ` (${(selected as string[]).length})`
                            : ''
                        }`
                      }
                    />

                    {formik.values.employments?.length > 0 && (
                      <div className={classes.chipRow}>
                        {formik.values.employments?.map((employment, idx) => (
                          <Chip
                            key={idx}
                            classes={{
                              root: classes.chipRoot,
                              label: classes.chipLabel
                            }}
                            label={
                              <div className={classes.chipLabelContainer}>
                                <Typography className={classes.chipLabel}>
                                  {employmentType(translate)[employment]}
                                </Typography>
                                <CloseIcon
                                  fontSize={'small'}
                                  onClick={() =>
                                    formik.setFieldValue(
                                      'employments',
                                      formik.values.employments.filter(
                                        (item) => item !== employment
                                      )
                                    )
                                  }
                                />
                              </div>
                            }
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  <div className={classes.inputStack}>
                    <Typography className={classes.dobLabelLocation}>
                      {locale === 'ru' ? 'Дополнительно' : 'Additional'}
                    </Typography>
                    <CustomSelect
                      multiple
                      value={formik.values.features}
                      name={'features'}
                      className={classes.selector}
                      onChange={formik.handleChange}
                      disabled={formik.isSubmitting}
                      options={Object.entries(featuresOptions(translate))?.map(
                        ([key, value]) => ({
                          value: key as NonNullable<typeof key>,
                          text: value as NonNullable<typeof value>
                        })
                      )}
                      renderValue={(selected) =>
                        `${locale === 'ru' ? 'Дополнительно' : 'Additional'}${
                          (selected as string[]).length > 0
                            ? ` (${(selected as string[]).length})`
                            : ''
                        }`
                      }
                    />
                    {formik.values.features.length > 0 && (
                      <div className={classes.chipRow}>
                        {formik.values.features?.map((feature, idx) => (
                          <Chip
                            key={idx}
                            classes={{
                              root: classes.chipRoot,
                              label: classes.chipLabel
                            }}
                            label={
                              <div className={classes.chipLabelContainer}>
                                <Typography className={classes.chipLabel}>
                                  {featuresOptions(translate)[feature]}
                                </Typography>
                                <CloseIcon
                                  fontSize={'small'}
                                  onClick={() =>
                                    formik.setFieldValue(
                                      'features',
                                      formik.values.features.filter(
                                        (item) => item !== feature
                                      )
                                    )
                                  }
                                />
                              </div>
                            }
                          />
                        ))}
                      </div>
                    )}
                  </div>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.remoteWork}
                        onChange={formik.handleChange}
                        name="remoteWork"
                        checkedIcon={<CheckboxIcon />}
                        icon={<CheckboxOffIcon />}
                        disabled={formik.isSubmitting}
                        color="secondary"
                      />
                    }
                    className={classes.checkBox}
                    label={
                      locale === 'ru'
                        ? 'По договорённости'
                        : 'Contractual agreement'
                    }
                  />
                  <div className={classes.inputStack}>
                    <Typography className={classes.dobLabelLocation}>
                      {`${
                        locale === 'ru'
                          ? 'Желаемая заработная плата'
                          : 'Desired Salary'
                      } (${
                        type === 'freelancer'
                          ? `${locale === 'ru' ? 'руб/час' : '$/hours'}`
                          : `${locale === 'ru' ? 'руб/мес' : '$/months'}`
                      })`}
                    </Typography>
                  </div>
                  <CustomTextField
                    placeholder={
                      locale === 'ru' ? 'Введите сумму' : 'Enter sum'
                    }
                    name="salary"
                    fullWidth
                    type="number"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur('salary')}
                    value={formik.values.salary}
                    touched={formik.touched.salary}
                    errors={
                      formik.values.remoteWork ? '' : formik.errors.salary
                    }
                    disabled={formik.isSubmitting || formik.values.remoteWork}
                  />
                </div>
              )}
              <div className={classes.formActions}>
                <Button
                  variant={'outlined'}
                  disabled={currentStepIndex < 1}
                  onClick={() => setCurrentStepIndex((prev) => prev - 1)}
                  classes={{
                    root: classes.buttonRoot,
                    label: classes.buttonLabel
                  }}
                >
                  {locale === 'ru' ? 'Назад' : 'Back'}
                </Button>
                <Typography>{currentStepIndex + 1} из 3</Typography>
                <Button
                  variant={'contained'}
                  color={'secondary'}
                  type={'submit'}
                  classes={{
                    root: classes.buttonRoot,
                    label: classes.buttonLabel
                  }}
                >
                  {currentStepIndex === 2
                    ? locale === 'ru'
                      ? 'Сохранить'
                      : 'Save'
                    : locale === 'ru'
                    ? 'Далее'
                    : 'Next'}
                </Button>
              </div>
            </form>
          </Card>
        </Grid>
      </>
    </Grid>
  )
}
